<section>
  <div class="row">
    <div class="col-md-10">
      <!--Row 1 Start-->
      <div class="row">
        <div class="col"><span><strong>{{orderLblText.orderNumberLbl}}:</strong></span></div>
        <div class="col"><span>{{orderHeaderGridData.sampleProductOrderNumber}}</span></div>
        <div class="col"><span><strong> {{orderLblText.createdDateLbl}}:</strong></span> </div>
        <div class="col"> <span>{{orderHeaderGridData.createdDate | date:'MM/dd/yy'}}</span></div>
      </div>
      <!--Row 1 End-->
      <!--Row 2 Start-->
      <div class="row">
        <div class="col"><span><strong>{{orderLblText.customerLbl}}:</strong></span></div>
        <div class="col"><span>{{orderHeaderGridData.customer}}</span></div>
        <div class="col"><span><strong> {{orderLblText.costLbl}}:</strong></span> </div>
        <div class="col"> <span>{{orderHeaderGridData.cost | currency}}</span></div>
      </div>
      <!--Row 2 End-->
      <!--Row 3 Start-->
      <div class="row">
        <div class="col"><span><strong>{{orderLblText.contactLbl}}:</strong></span></div>
        <div class="col"><span>{{orderHeaderGridData.contact}}</span></div>
        <div class="col"><span><strong> {{orderLblText.regionLbl}}:</strong></span> </div>
        <div class="col"> <span>{{orderHeaderGridData.region}}</span></div>
      </div>
      <!--Row 3 End-->
      <!--Row 4 Start-->
      <div class="row">
        <div class="col"><span><strong>{{orderLblText.contactEmailLbl}}:</strong></span></div>
        <div class="col"><span>{{userEmail}}</span></div>
        <div class="col"><!--<span><strong> {{orderLblText.trackingMethodLbl}}:</strong></span>--> </div>
        <div class="col"> <span></span></div>
      </div>
      <!--Row 4 End-->
      <!--Row 5 Start-->
      <div class="row">
        <div class="col"><span><strong>{{orderLblText.ccEmailLbl}}:</strong></span></div>
        <div class="col"><span>{{orderHeaderGridData.ccEmail}}</span></div>
        <div class="col"><!--<span><strong> {{orderLblText.trackingNumberLbl}}:</strong></span>--> </div>
        <div class="col"> <span></span></div>
      </div>
      <!--Row 5 End-->
    </div>
  </div>
</section>

<section>
  <p class="row">
    <span class="sample-request-order-summary"><strong>{{orderDetailsLblText.orderSummaryLbl}}</strong>:</span>
  </p>
  <kendo-grid [data]="orderDetailsGridData"
              class="orderSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="orderGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="orderGridstate.take"
              [skip]="orderGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="orderDetailsGridSortChange($event)"
              (pageChange)="orderDetailsGridPageChange($event)"
              (dataStateChange)="orderDetailsGridDataStateChange($event)"
              [filter]="orderGridSettings.state.filter"
              [loading]="orderLoading">
    <!--(columnReorder)="onReorder($event)"-->
    <!--(columnVisibilityChange)="onVisibilityChange($event)"-->
    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{orderDetailsLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{orderDetailsLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of orderGridSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">

      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'cost'">
        {{dataItem.cost | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
    <!--[data]="data"-->
    <kendo-excelexport [collapsible]="true" fileName="SampleProductOrderDetails.xlsx" #excelexport>
      <kendo-excelexport-column field="stockNum" title="Stock Number" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="subCategoryDescription" title="Product Description" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="quanity" title="Quantity" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="cost" title="Cost" [width]="150">
      </kendo-excelexport-column>

    </kendo-excelexport>

  </kendo-grid>
</section>



<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button class="m-3 btn btn-success" [routerLink]="['sample-request-admin/sample-request-order-history']"
           style="margin: 0 auto;"
          kendoButton (click)="redirectToOrderHistoryPage()">
    Back
  </button>
</div>
